import { WorkOfflineDataFetcher } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { API_ENDPOINTS } from '../../type-api-endpoint-mapping';

export interface Work {
    id: string;
    type: string;
}

declare var WORK_SEARCH_TYPES

export class WorkDataStore extends EntityDataStore<Work> {
    public static getInstance() {
        if (!WorkDataStore.instance) {
            WorkDataStore.instance = new WorkDataStore();
        }

        return WorkDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$workDataStore = WorkDataStore.getInstance();
    }

    private static instance: WorkDataStore = null as any;

    constructor() {
        super('works', WORK_SEARCH_TYPES);
    }

    public update(id: string, body: Partial<Work>, endpointOverride?: string) {
        return super.update(id, body, endpointOverride || API_ENDPOINTS[body.type as string])
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new WorkOfflineDataFetcher(this.sanitizedIdentifer); // TODO refactor to constant
    }
}
